import { Configuration } from 'dev-corize-api-client';
import { UserManager, UserManagerSettings } from 'oidc-client';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { CorizeEnvironment } from '../models/corize-environment';
 
export abstract class BaseAuthService {
  public _authStatusSource = new BehaviorSubject<boolean>(false);
  public returnUrl : string ="";
  public authStatus$ = this._authStatusSource.asObservable();

  private currentUserSubject = new BehaviorSubject<any>({});
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  public loggedIn : boolean = false;

  constructor(protected corize: CorizeEnvironment, private apiConfiguration: Configuration) {
    var t = this;
    this.returnUrl = `${window.location.origin}/auth-callback`;
    this.manager = new UserManager(this.getConfig());
    this.manager.getUser().then((user) => {
      if (user) { 
        t.loggedIn = true;
        t.corize.setUser(user);
        t.corize.AuthorizatioHeader = this.getAuthorizationHeaderValue();        
        t.apiConfiguration.credentials["oauth2"] = this.getAuthorizationHeaderValue();
        t.getUserInformation();
        t.setUser(user);
      } else { 
        t.loggedIn = false;
        t.corize.AuthorizatioHeader = "";
        t.apiConfiguration.credentials["oauth2"] = "";
      }
      this._authStatusSource.next(this.isAuthenticated());
    }).catch((err) => { 
      t.loggedIn = false;
    });
  }
  public manager: UserManager;
  abstract getAuthorizationHeaderValue(): string;
  abstract getPermissions(): any;
  abstract getRoles(): any;
  abstract isAuthenticated(): boolean
  abstract getUserInformation();
  abstract getConfig():UserManagerSettings;
  abstract logout();
  abstract authComplete();

  setUser(user) {        
    this.currentUserSubject.next(user);
  }

  async completeAuthentication() { 
    this.manager.signinRedirectCallback()
      .then(user => { 
        this.loggedIn = true;
        this.corize.setUser(user); 
        this.apiConfiguration.credentials["oauth2"] =this.getAuthorizationHeaderValue();
        this.corize.AuthorizatioHeader = this.getAuthorizationHeaderValue(); 
        this.getUserInformation();
        this.setUser(user);
        this.authComplete();
        this._authStatusSource.next(this.isAuthenticated())

      })
      .catch(error => { 
        this.loggedIn = false;        
        this.corize.AuthorizatioHeader = "";
        this.apiConfiguration.credentials["oauth2"] ="";
        alert(error);
      });
  } 
}
